module.exports = __webpack_public_path__ + "static/media/oumar 1.28b58355.svg";